module.exports = __webpack_public_path__ + "atm.5e904448c5bfa6698be1af0a7bfaeae3.svg";